export default "__VITE_ASSET__C9AABSW9__"